export enum ShipmentPriceValuePropertyName {
  MIN_PRICE = 'minPrice',
  AVG_PRICE = 'avgPrice',
}
